import { render, staticRenderFns } from "./DeleteQuestionnaireBtn.vue?vue&type=template&id=6ffbafc8"
import script from "./DeleteQuestionnaireBtn.vue?vue&type=script&lang=js"
export * from "./DeleteQuestionnaireBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports